var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3931,
    height: 1237,
    viewBox: "0 0 3931 1237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_848_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.598 295.273C253.509 283.613 252.295 276.512 256.253 265.165C259.256 260.199 262.705 254.789 270.496 252.942C298.334 246.344 328.842 252.283 356.775 259.062C386.931 266.381 415.855 276.742 442.511 288.433C498.169 312.842 551.584 338.594 608.975 361.488C679.092 389.46 749.016 411.962 827.181 428.42C912.698 446.425 999.799 459.09 1087.71 469.703C1334.71 499.523 1584.16 527.042 1833.42 541.671C1955.58 548.841 2079.83 554.471 2200.35 543.585C2295.54 534.987 2389.01 517.719 2477.11 495.271C2568.95 471.869 2652.3 439.615 2738.11 409.329C2843.99 371.956 2953.23 337.182 3067.16 309.594C3159.61 287.207 3259.95 264.568 3362.6 267.753C3433.55 269.955 3503.94 285.565 3565.5 309.624C3621.62 331.557 3664.61 362.823 3676.21 404.056C3690.22 453.826 3667.93 507.982 3640.66 552.934C3611.47 601.05 3566.77 644.714 3519.66 686.099C3478.82 721.971 3433.29 755.427 3382.76 785.957C3233.23 876.309 3031.35 926.645 2827.84 953.65C2709.87 969.304 2588.87 979.841 2467.33 982.901C2353.76 985.76 2239.27 986.373 2125.35 986.05C2013.68 985.734 1902.38 980.564 1790.86 972.164C1644.93 961.172 1498.65 947.3 1355.84 921.845C1209.71 895.796 1066.68 860.713 934.97 810.856C850.249 778.785 770.31 741.581 689.714 705.444C627.732 677.655 566.646 650.013 512.734 615.738C451.727 576.952 413.911 546.889 364.091 501.874C324.765 466.339 279.891 424.952 260.601 382.763C258.852 378.939 255.386 359.501 254.671 355.147C251.406 335.276 248.363 315.006 251.598 295.273Z",
    fill: "url(#paint0_radial_848_387)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_848_387",
    x: 0.217773,
    y: 0.0717773,
    width: 3930.31,
    height: 1236.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_848_387"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_848_387",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1965.6 440.392) rotate(88.8757) scale(474.837 2049.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#8961F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.4d286e524492b1705ad9c00ed34a7632.svg";
export { ForwardRef as ReactComponent };